import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { translate } from "../../../translations/localization";
import "../styles.scss";
import euImage from '../../../assets/images/eu-Project.png'

export const SecondHome = ({ setIsOpened }) => {
  const [productsList] = useState([
    {
      name: translate("secondHome.point1.title"),
      img: "/home2/1.webp",
      description: translate("secondHome.point1.text"),
      pdf: false,
    },
    {
      name: translate("secondHome.point2.title"),
      img: "/home2/2.webp",
      pdf: false,
    },
    {
      name: translate("secondHome.point3.title"),
      img: "/home2/3.webp",
      pdf: false,
    },
    {
      name: translate("secondHome.point4.title"),
      img: "/home2/4.webp",
      pdf: false,
    },
    {
      name: translate("secondHome.point5.title"),
      img: "/home2/5.webp",
      pdf: false,
    },
    {
      name: translate("secondHome.point6.title"),
      img: "/home2/6.webp",
      pdf: false,
    },
    {
      name: translate("secondHome.point7.title"),
      img: "/home2/7.webp",
      description: translate("secondHome.point7.text"),
      pdf: false,
    },
    {
      name: translate("secondHome.point8.title"),
      img: "/home2/8.webp",
      description: translate("secondHome.point8.text"),
      pdf: false,
    },
    {
      name: translate("secondHome.point9.title"),
      img: "/home2/9.webp",
      pdf: false,
    },
    {
      name: translate("secondHome.point10.title"),
      img: "/home2/10.webp",
      pdf: false,
    },
    {
      name: translate("secondHome.point11.title"),
      img: "/home2/11.webp",
      pdf: false,
    },
    {
      name: translate("secondHome.point12.title"),
      img: "/home2/12.webp",
      pdf: false,
    },
    {
      name: translate("euTitle"),
      img: "/home/hydrotank.webp",
      description: translate("euDescription"),
      pdf: false,
      isEuProject: true, // Flag to identify this special item
    },
  ]);
  const [prevSelectedId, setPrevSelectedId] = useState("");

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".box-info")) {
        if (prevSelectedId !== "") {
          document.getElementById(`box-dashed-second-${prevSelectedId}`).className = "box-lines";
          document.getElementById(`box-info${prevSelectedId}`).className = "box-info";
          setIsOpened(false);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [prevSelectedId]);

  const productsToggle = (id) => {
    let boxPoint = document.getElementById("box-point-second-" + id);
    let boxInfo = document.getElementById("box-info" + id);
    let boxDashed = document.getElementById("box-dashed-second-" + id);

    boxInfo.className = "box-info box-info-active";
    boxDashed.className = "box-dashed-active";

    let screenHeight = document.body.clientHeight;
    let bgHeight = document.getElementById("bg").offsetHeight;
    let pointPosition = boxPoint.offsetTop; // top space to 'bg' parent element
    let boxInfoPosition = boxInfo.getBoundingClientRect().top;

    let boxDashedHeight = boxInfoPosition - (pointPosition - (bgHeight - screenHeight) / 2) - 11;

    boxDashed.getElementsByClassName("box-dashed")[0].style.height = boxDashedHeight + 0 + "px";

    //hide previous selected elements
    let prevId = prevSelectedId;
    if (prevId !== "") {
      if (id !== prevId) {
        document.getElementById("box-info" + prevId).className = "box-info";
        document.getElementById("box-dashed-second-" + prevId).className = "box-lines";
      }
    }
    setPrevSelectedId(id);
    setIsOpened(true);
  };

  let structuredJSON = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "HydroPro Ltd",
    image: "https://hydropro.bg/HydroPro-color.png",
    "@id": "",
    url: "https://hydropro.bg/",
    address: {
      "@type": "PostalAddress",
      streetAddress: "bul. Tsarigradsko shose 164",
      addressLocality: "Sofia",
      postalCode: "1138",
      addressCountry: "BG",
    },
  };

  const productsListPoints = productsList.map(
    (productsList, index) =>
      productsList.name && (
        <div key={index} id={"box-point-second-" + index}>
          <div className="box-point" onClick={() => productsToggle(index)}>
            <span className="point"></span>
          </div>
        </div>
      )
  );

  const productsListBoxDashed = productsList.map((productsList, index) => (
    <div key={index} id={"box-dashed-second-" + index} className="box-lines">
      <div className="box-dashed">
        <img src="/home/dot.svg" alt="home" />
      </div>
      {index === 8 ? (
        <div className="box-dashed box-dashed-2">
          <img src="/home/dot.svg" alt="home" />
        </div>
      ) : null}
    </div>
  ));

  const productsListBoxInfo = productsList.map(
    (product, index) => {
      // Special rendering for EU Project item
      if (product.isEuProject) {
        return (
          <div key={index} className="eu-project-info" id={"box-info" + index}>
            <div className="eu-project-content">
              {product.link ? (
                <Link to={product.link}>
                  <h1 className="eu-project-title">{product.name}</h1>
                </Link>
              ) : (
                <h1 className="eu-project-title">{product.name}</h1>
              )}
              <p className="eu-project-description">{product.description}</p>
            </div>
          </div>
        );
      }
      
      // Standard rendering for all other products
      return product.name ? (
        <div key={index} className="box-info" id={"box-info" + index}>
          <div className="cell-info">
            {product.link ? (
              <Link to={product.link}>
                <div style={{ display: "flex", alignItems: "center", marginBottom: "15px" }}>
                  <h1 className="">{product.name}</h1>
                  <div className="navigate-arrow" />
                </div>
              </Link>
            ) : (
              <h1 dangerouslySetInnerHTML={{ __html: product.name }}></h1>
            )}
            <p style={{ marginTop: "10px" }} dangerouslySetInnerHTML={{ __html: product.description }}></p>
          </div>

          <div className="cell-img">
            {product.link ? (
              <Link to={product.link}>
                <img src={product.img} alt={product.name} />
              </Link>
            ) : (
              <img src={product.img} alt={product.name} />
            )}
          </div>
        </div>
      ) : null;
    }
  );
  
  return (
    <>
      <script className="structured-data-list" type="application/ld+json">
        {JSON.stringify(structuredJSON)}
      </script>
      <div className="bg" id="bg">
        {productsListPoints}
        <div id="box-point-second-eu-screen">
          <div className="box-point" onClick={() => productsToggle(12)}>
            <span className="point"></span>
          </div>
        </div>
        {productsListBoxDashed}
        <div id="box-dashed-second-eu-screen" className="box-lines">
          <div className="box-dashed">
            <img src="/home/dot.svg" alt="home" />
          </div>
        </div>
        <img src="/home/bg-2@2x.png" alt="HYDROPRO" className="desktop bg-img" style={{ height: "100vh" }} />
        <img src="/home/bg-2@2x.png" alt="HYDROPRO" className="laptop bg-img" style={{ height: "100vh" }} />
        <img src={euImage} alt="eu image" className="euImageSecondScreen" id="euImageTargetSecondScreen" />
      </div>
      {productsListBoxInfo}
      
    </>
  );
};
